import React from 'react'

export default function LearnMore({url}) {
    return (
        <div>
            <p className="integrations-col__link" onClick={() => window.open(url, "_blank")}>learn more</p>
        </div>
    )
}
